/* global PDFViewerApplication */

import PDF from "../website-behaviors/PDF.js";
import Citation from "../citation.js";

class JSTORPdf extends PDF {
	identifier() {
		return "JSTORPdf";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "jstor.org" || location.host === "www.jstor.org")
			&& location.pathname.startsWith("/stable/pdf/");
	}

	/**
	 * Loads RIS export URL, e.g. https://www.jstor.org/citation/ris/3649391
	 */
	async generateStructuredCitation() {
		// @ts-expect-error FIXME
		const url = new URL(PDFViewerApplication.baseUrl);

		// Get "123456789" from URL like "www.jstor.org/stable/pdf/123456789.pdf"
		const documentId = parseInt(url.pathname.split("/")[3], 10);
		if (!documentId)
			return null;

		const risUrl = new URL(`${url.protocol}//${url.hostname}/citation/ris/${documentId}`);
		const response = await fetch(risUrl);
		if (response.status !== 200)
			return null;

		return Citation.fromRIS(await response.text());
	}
}

export default JSTORPdf;
